<template>
  <div class="alibabaorderv2">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代購委託單</a>
      </nav>

      <ul class="list-group">
        <div class="card">
          <div class="card-body">
            <div class="title">加入購物車</div>
            <p>
              阿里巴巴網址範例:
              <br />https://detail.1688.com/offer/800120939317.html 或
              https://m.1688.com/offer/800120939317.html
            </p>
            <p>請貼入阿里巴巴商品網址，於下方輸入框，點選「加入商品」:</p>
            <div ref="searchUrl">
              <b-form-input
                v-model="searchUrl"
                placeholder="貼入阿里巴巴商品網址"
              ></b-form-input>
              <br />
              <button
                class="btn btn-primary btn-block"
                v-on:click="clickSearchUrl()"
              >
                加入商品
              </button>
            </div>
          </div>
        </div>
      </ul>
      <b-alert show variant="info"
        >低風險批貨，申請委託單都是免費的，得到代買幫報價後可取消委託單</b-alert
      >
      <!--  /////////////////////////////// -->
      <div v-if="orders.length != 0">
        <div class="card">
          <div class="row">
            <div class="title col-9 ml-3" style="text-align: left">
              👇商品購物車
              <b>({{ addToCartCount }})</b>
            </div>
            <b-button
              class="col-2 mt-3 mr-2"
              variant="outline-info"
              type="button"
              @click="deleteOrders()"
              >刪除</b-button
            >
          </div>
          <div
            class="card-body"
            v-for="(order, index) in orders"
            v-bind:key="(order, index)"
          >
            <div class="card">
              <div class="card-body">
                <h5>{{ order.prod_name }}</h5>
                <p>*請注意此商品起批數為{{ order.buy_base_line }}</p>
                <h6>顏色:</h6>
                <div class="row">
                  <div
                    class="card col-6"
                    style="margin: 0 auto; float: none; margin-bottom: 10px"
                    v-for="(color_info, color_index) in order.color_info"
                    v-bind:key="(color_info, color_index)"
                  >
                    <img
                      class="card-img-top"
                      v-bind:src="color_info.color_image"
                      style="width: 100%"
                      alt="Card image cap"
                      referrerpolicy="no-referrer"
                    />
                    <div class="card-body">
                      <h5>{{ color_info.color_name }}</h5>
                      <div class="card-text">
                        <b-form-group label="選取:" class="col-12 pt-2">
                          <div>
                            <b-form-radio
                              v-model="order.color_selected"
                              v-bind:name="'some_radios' + order.prod_uid"
                              v-bind:value="color_index"
                              >{{ color_info.color_name }}</b-form-radio
                            >
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-3">
                    <h6>規格:</h6>
                  </div>

                  <div
                    class="col-12"
                    v-for="(sku_info, sku_index) in order.sku_info"
                    v-bind:key="(sku_info, sku_index)"
                  >
                    <div class="row">
                      <div class="col-6">
                        <p>{{ sku_info.sku_name }}</p>
                      </div>

                      <div class="col-6">
                        <p>數量:</p>

                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              @click="lessAmounts(index, sku_index)"
                            >
                              -
                            </button>
                          </div>
                          <input
                            type="number"
                            class="form-control"
                            placeholder
                            aria-label="inputAmounts"
                            v-model="order.sku_info[sku_index].amount"
                            @change="updateAmounts()"
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              @click="addAmounts(index, sku_index)"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <hr />
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-12 mt-3 mb-3">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="ignoreBaseLine"
                      name="checkbox-1"
                      value="false"
                      unchecked-value="true"
                      @change="ignoreBaseLineCheck(ignoreBaseLine)"
                    >打樣商品(只購買一個)</b-form-checkbox>
                  </div>-->

                  <div class="col-12">
                    <h6>備註細節:</h6>
                  </div>
                  <div class="col-12">
                    <b-form-textarea
                      id="textarea-rows"
                      placeholder="例如:需要與廠商溝通降低起批數，需要廠商特別配合...等"
                      rows="2"
                      v-model="order.prod_detail"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  /////////////////////////////// -->

      <div v-if="orders.length != 0">
        <br />
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          @click="submit()"
        >
          繼續完成委託單申請
        </button>
      </div>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'alibabaorderv2',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      skuInfo: [],
      buyBaseLine: 1,
      isLoading: true,
      searchUrl: '',
      ProdInfosArray: [],
      inputAmounts: [],
      checkMobile: isMobile ? '1' : '0',
      prodDetail: '',
      ignoreBaseLine: true,
      addToCartCount: 0,
      orders: [],
    }
  },
  methods: {
    submit: function () {
      const vm = this

      let count = 0
      for (let order of vm.orders) {
        if (order.color_info.length == 1) {
          vm.orders[count].color_selected = 0
        }
        if (order.color_info.length > 0) {
          if (order.color_selected == undefined) {
            vm.$toast.open({
              message: '請選擇顏色!',
              type: 'error',
            })
            return 0
          }
        }
        if (order.sku_info.length > 0) {
          let count = 0
          order.sku_info.forEach(element => {
            count = parseInt(count) + parseInt(element.amount)
          })
          if (count == 0) {
            vm.$toast.open({
              message: '請輸入數量!',
              type: 'error',
            })
            return 0
          }
        }
        count++
      }

      console.log(JSON.stringify(vm.orders))

      if (vm.orders) {
        let count = 0
        for (let order of vm.orders) {
          if (order.color_info.length > 0) {
            vm.orders[count].color_name_selected =
              order.color_info[order.color_selected].color_name
            vm.orders[count].color_image_selected =
              order.color_info[order.color_selected].color_image
          }
          // input user info
          if (localStorage.userId) {
            vm.orders[count].user_id = localStorage.userId
          }
          if (localStorage.userImage) {
            vm.orders[count].user_image = localStorage.userImage
          }
          if (localStorage.userName) {
            vm.orders[count].user_name = localStorage.userName
          }
          count++
        }

        vm.$store.newprodInfos = vm.orders
        localStorage.setItem('newprodInfos', JSON.stringify(vm.orders))

        vm.$forceUpdate()
        vm.$router.push('profilev2')
      }
    },
    clickSearchUrlFormat: function (url) {
      const vm = this
      // https: //detail.1688.com/offer/571008951577.html 或
      //   https: //m.1688.com/offer/571008951577.html 或
      // http://detail.m.1688.com/page/index.htm?offerId=601733052815

      let aibabaRegexs = []
      let isAibabaUrl = false
      let desktopAibabaRegex = /detail.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAibabaRegex = /m.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAppAibabaRegex =
        /detail.m.1688.com\/page\/index\.htm\?offerId=[0-9]{8,12}/g

      aibabaRegexs.push(desktopAibabaRegex)
      aibabaRegexs.push(mobileAibabaRegex)
      aibabaRegexs.push(mobileAppAibabaRegex)

      let checkMatchAibabaUrl = []
      let matchAibabaOfferId = ''
      aibabaRegexs.forEach(aibabaRegex => {
        checkMatchAibabaUrl = url.match(aibabaRegex)

        if (
          checkMatchAibabaUrl != undefined &&
          checkMatchAibabaUrl.length != 0
        ) {
          if (checkMatchAibabaUrl[0].split('offer/')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offer/')[1]
          } else if (checkMatchAibabaUrl[0].split('offerId=')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offerId=')[1]
          } else {
            isAibabaUrl = false
          }

          isAibabaUrl = true
        }
      })

      if (isAibabaUrl) {
        vm.searchUrl =
          'https://detail.1688.com/offer/' + matchAibabaOfferId + '.html'

        return true
      } else {
        vm.$toast.open({
          message:
            '輸入的 ' +
            vm.searchUrl +
            ' 網址格式錯誤，如果使用阿里巴巴App長按商品名稱抓取網址',
          type: 'error',
        })

        vm.isLoading = false
        return false
      }
    },
    clickSearchUrl: function () {
      const vm = this
      // vm.isLoading = true;

      let loader = vm.$loading.show({
        container: vm.$refs.searchUrl,
      })

      let urlIsValid = vm.clickSearchUrlFormat(vm.searchUrl)

      if (urlIsValid) {
        vm.$toast.open({
          message: '解析網站中，大概需要15秒，請稍等片刻...',
          type: 'success',
        })

        let formData = {
          parseUrl: vm.searchUrl,
        }
        axios
          .post(vm.apiUrl + 'ParseDataToDbV2', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            vm.buyBaseLine = vm.parseAlibabaBaseLine(response.data)
            let tempOrder = {}
            tempOrder = JSON.parse(JSON.stringify(response.data))
            tempOrder.buy_base_line = vm.buyBaseLine
            tempOrder.prod_url = vm.searchUrl
            tempOrder.prod_uid = vm.$uuid.v4()

            localStorage.setItem(
              'recommendInfo',
              JSON.stringify(tempOrder.recommend_info)
            )

            let index = 0
            tempOrder.sku_info.forEach(function () {
              tempOrder.sku_info[index].amount = 0
              tempOrder.sku_info[index].is_special_prod = '0'
              tempOrder.sku_info[index].prod_weight = 0
              tempOrder.sku_info[index].prod_length = 0
              tempOrder.sku_info[index].prod_width = 0
              tempOrder.sku_info[index].prod_height = 0
              index++
            })

            vm.orders.unshift(tempOrder)

            vm.$store.newprodInfos = vm.orders
            localStorage.setItem('newprodInfos', JSON.stringify(vm.orders))

            vm.addToCartCount = vm.orders.length
            console.log(JSON.stringify(tempOrder))
            // vm.isLoading = false;
            loader.hide()

            vm.searchUrl = ''
            vm.$toast.open({
              message: '解析成功',
              type: 'success',
            })
          })
          .catch(function (error) {
            // console.log(error);
            loader.hide()
            vm.$toast.open({
              message: '解析失敗: ' + error,
              type: 'error',
            })
            vm.$modal.show('dialog', {
              title: '🙋請聯絡客服',
              text: '請聯絡客服⚡ 告訴我們您網站解析發生了問題!',
              buttons: [
                {
                  title: '👉聯絡客服',
                  handler: () => {
                    window.location = 'https://m.me/2266831083395361'
                  },
                },
              ],
            })
          })
        vm.$forceUpdate()
      } else {
        loader.hide()
      }
    },
    parseAlibabaBaseLine: function (data) {
      let baseLine = 1
      if (data.amount_info.length >= 1) {
        let amountString = data.amount_info[0].amount_count

        console.log('amountString: ' + amountString)

        if (amountString.startsWith('≥')) {
          baseLine = amountString.split('≥')[1]
        } else if (amountString.indexOf('-') !== -1) {
          baseLine = amountString.split('-')[0]
        }
      }
      return baseLine
    },
    updateAmounts: function () {
      const vm = this
      // console.log(JSON.stringify(vm.skuInfo[index]));
      vm.$store.newprodInfos = vm.orders
      localStorage.setItem('newprodInfos', JSON.stringify(vm.orders))
      vm.$forceUpdate()
    },
    lessAmounts: function (index, sku_index) {
      const vm = this
      console.log(index, sku_index)

      let amount = Number(vm.orders[index].sku_info[sku_index].amount) - 1
      if (!amount || amount <= 0) {
        amount = 0
      }

      vm.orders[index].sku_info[sku_index].amount = amount

      // console.log(JSON.stringify(vm.skuInfo));
      vm.updateAmounts()
    },
    addAmounts: function (index, sku_index) {
      const vm = this
      let amount = Number(vm.orders[index].sku_info[sku_index].amount) + 1
      if (!amount) {
        amount = 1
      }

      vm.orders[index].sku_info[sku_index].amount = amount

      // console.log(JSON.stringify(vm.skuInfo));
      vm.updateAmounts()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        if (vm.userId) {
          vm.$modal.show('dialog', {
            title: '🙋您尚未登入FB會員',
            text: '請先登入才能使用此服務喔⚡',
            buttons: [
              {
                title: '👉用FB登入',
                handler: () => {
                  window.location = 'https://m.me/2266831083395361'
                },
              },
            ],
          })
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    ignoreBaseLineCheck: function (ignoreBaseLine) {
      const vm = this
      vm.$store.state.ignoreBaseLine = ignoreBaseLine
    },
    deleteOrders: function () {
      const vm = this
      vm.orders = []
      vm.$store.newprodInfos = vm.orders
      localStorage.setItem('newprodInfos', JSON.stringify(vm.orders))

      vm.$forceUpdate()
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = false
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()
    if (vm.$store.addBuyUrl != '') {
      vm.searchUrl = vm.$store.addBuyUrl
    }

    if (vm.$store.newprodInfos != undefined) {
      vm.ProdInfosArray = vm.$store.newprodInfos.concat()
      vm.orders = JSON.parse(JSON.stringify(vm.ProdInfosArray))

      vm.addToCartCount = vm.ProdInfosArray.length

      vm.isLoading = false
    } else if (JSON.parse(localStorage.getItem('newprodInfos')) != undefined) {
      vm.ProdInfosArray = JSON.parse(
        localStorage.getItem('newprodInfos')
      ).concat()
      vm.orders = JSON.parse(JSON.stringify(vm.ProdInfosArray))

      vm.addToCartCount = vm.ProdInfosArray.length

      vm.isLoading = false
    }
  },
}
</script>
